import React, { FC, useCallback } from 'react';
import { FilterRadioHidden } from 'Components/FilterRadioHidden';
import Dropdown from 'Components/Dropdown';
import withErrorBoundary from 'HOC/ErrorBoundary';

interface Props {
  callback?: (event: any, identifier: any) => void;
  activityWithEAB?: any;
}

const options = [
  // Get this from Redux
  { label: 'Within Last 7 Days', value: 'Within_Last_7_Days' },
  { label: 'Within Last 30 Days', value: 'Within_Last_30_Days' },
  { label: 'Within Last 90 Days', value: 'Within_Last_90_Days' },
  { label: 'Within Last 365 Days', value: 'Within_Last_365_Days' },
];
const overrideStyles = { color: '#079DC0' };

const ActivityWithEab: FC<Props> = (props: Props) => {
  const { callback, activityWithEAB } = props;

  const handleDropDownChange = (e: any, id: string) => {
    // Find the selected value
    const value = e.target.value.toLocaleLowerCase();
    const selectedOption = options.find(
      (option) => option.value.toLocaleLowerCase() === value
    );

    callback({ target: { value: selectedOption, id } }, id);
  };
  const activityWithEABCallBack = (e: any) => {
    // Pass the identifier back to the callback
    callback(e, 'activityWithEAB');
  };
  const colorOverRide = {
    open: {
      border: {
        color: '#B4E1EC',
      },
      text: {
        color: '#079DC0',
      },
    },
    close: {
      border: {
        color: '#B4E1EC',
      },
      text: {
        color: '#079DC0',
      },
    },
  };

  return (
    <>
      <FilterRadioHidden
        label="Any"
        value="Any"
        overrideStyles={overrideStyles}
        selected={activityWithEAB.selection === 'Any'}
        identifier="activityWithEAB"
        onClick={useCallback(activityWithEABCallBack, [activityWithEAB])}
      />
      <FilterRadioHidden
        label="Active"
        value="Active"
        overrideStyles={overrideStyles}
        selected={activityWithEAB.selection === 'Active'}
        identifier="activityWithEAB"
        onClick={useCallback(activityWithEABCallBack, [activityWithEAB])}
      >
        <Dropdown
          ariaLabel="Select Activity with EAB"
          colorOverRide={colorOverRide}
          items={options}
          defaultValue={
            activityWithEAB.selection === 'Active'
              ? activityWithEAB.value
              : null
          }
          onChange={useCallback(
            (e: any) => {
              // Pass the identifier
              handleDropDownChange(e, 'Active');
            },
            [activityWithEAB]
          )}
        />
      </FilterRadioHidden>
      <FilterRadioHidden
        label="Inactive"
        value="Inactive"
        overrideStyles={overrideStyles}
        selected={activityWithEAB.selection === 'Inactive'}
        identifier="activityWithEAB"
        onClick={useCallback(activityWithEABCallBack, [activityWithEAB])}
      >
        <Dropdown
          ariaLabel="Select Inactivity with EAB"
          colorOverRide={colorOverRide}
          items={options}
          defaultValue={
            activityWithEAB.selection === 'Inactive'
              ? activityWithEAB.value
              : null
          }
          onChange={useCallback(
            (e: any) => {
              // Pass the identifier
              handleDropDownChange(e, 'Inactive');
            },
            [activityWithEAB]
          )}
        />
      </FilterRadioHidden>
    </>
  );
};

ActivityWithEab.defaultProps = {
  callback: () => {},
  activityWithEAB: undefined,
};

export default withErrorBoundary(ActivityWithEab);
